// Parse take off string to rwy data object
export const tkofToRwyData = (str, filterTora = true) => {
  const regex =
    /(?:;|^)(\d+[A-Z]*[0-9A-Z]*)(?:(?:\[)(\d+);(\d+);(\d+);(\d+)(?:\]))?/g;
    const runways = [];
  
    let match;
    while ((match = regex.exec(str)) !== null) {
        const [, rwy, rwyHeading, tora, lda, rwyWidth] = match;
        runways.push({
            rwy: rwy,
            rwyHeading: rwyHeading ? parseInt(rwyHeading) : null,
            tora: tora ? parseInt(tora) : null,
            lda: lda ? parseInt(lda) : null,
      rwyWidth: rwyWidth ? parseInt(rwyWidth) : null,
        });
    }
  
    // Filter out runways with no tora
    if (filterTora) {
    const filteredRunways = runways.filter((runway) => runway.tora);
        return filteredRunways;
    }

  return runways;
};
